import React, { Component } from 'react'
import { connect } from 'react-redux'
import '../../../styles/checkout/mainStyle.css'
import PreloadImage from '../../../images/preloadJSON.PNG'
import { selectResponse } from '../../../actions/commonActions'
import { makePreloadRequest, setPreloadRequestMessage } from '../../../actions/checkoutActions'
import { _MCO } from '../../../actions/types'

export class PreloadRequest extends Component {
    state = {
        topRef: React.createRef(),
        firstCheck:true,
        showError:false,
        showSuccess:false,
        justClicked:false,
    }

    onScrollToTop() {
        this.state.topRef.current.scrollIntoView()
        window.document.body.scrollIntoView(true)
    }

    constructor(props) {
        super(props);    
        this.handleChange = this.handleChange.bind(this);
        this.handleOnclickButton = this.handleOnclickButton.bind(this)
    }

    handleChange(event) {
        this.props.setPreloadRequestMessage( event.target.value);
    }
    
    handleOnclickButton(PreoloadPrequestMessage,storeId, apiToken, checkoutId,txnTotal){
        this.props.selectResponse({ featureId: _MCO, responseId: 2 })
        this.props.makePreloadRequest(PreoloadPrequestMessage,storeId, apiToken, checkoutId, txnTotal)
        this.setState({justClicked:true})
    }

    componentDidUpdate() {
        if(this.props.PreoloadPrequestResponse.response){
            if(this.props.ticket!=='' && this.state.justClicked){
                if(this.props.PreoloadPrequestResponse.response.success==='true') {               
                    this.setState({ showError: false, firstCheck:false,showSuccess: true,justClicked:false });  
                }
                else {
                    this.setState({  showError: true,firstCheck:false, showSuccess: false,justClicked:false });
                }
            }
        }
    }

    renderMessage() {
        if(this.state.showError) {
            return (
                <div style={{ marginTop:'1vh', marginRight: '3vw',backgroundColor:'#ffcccc', color:'#cc0000', padding:'1vw', borderRadius:'10px', border:'1px solid #ff8080', lineHeight: '3vh'}}><strong>Error!</strong><br />Please check your parameters within preload request.</div>
            );
        }
        else if(this.state.showSuccess) {
            return (
                <div style={{ marginTop:'1vh', marginRight: '3vw',backgroundColor:'#d6f5d6', color:'#196719', padding:'1vw', borderRadius:'10px', border:'1px solid #6fdc6f', lineHeight: '3vh'}}><strong>Ticket Number Accepted!</strong><br />The returned ticket number has been inserted to the JSON on the right, you can make a Display Checkout Request now.</div>
            );
        }
    }

    renderDocument(){
        return (
            <div className= "stepPageContainer">  
                    <h3 ref={this.state.topRef} className="stepPageTitle">Preload Request</h3> 
                    <p>The Preload request is the means by which a Moneris Checkout instance is securely generated at transaction time. It involves a server-to-server post using the JSON format.</p>
                    <p>The response to the Preload request returns a ticket number which uniquely identifies the instance and must be passed in the JavaScript</p>
                    <div style={{ fontWeight: "bold", fontSize: "1.1em",marginTop:"2vh" }}> 
                    <pre>
                        <span id="code5">
                            myCheckout.startCheckout(ticket#);
                        </span>
                    </pre>
    
                    </div>
                    <p>request in order to display the Moneris Checkout page in the browser.</p>
                    <p>In your server implementation, use the following Moneris Checkout URLs to post to, depending on the development stage:</p>
                    <p>Testing:</p> <a href="https://developer.moneris.com" target="_blank" rel="noopener noreferrer">https://gatewayt.moneris.com/chktv2/request/request.php</a><br></br><br></br>
                    <p>Production:</p> <a href="https://developer.moneris.com" target="_blank" rel="noopener noreferrer">https://gateway.moneris.com/chktv2/request/request.php</a><br></br><br></br>
                    <p>Transaction requests are sent to the Moneris Checkout server using JSON.</p>
                        
                    <h3>JSON structure overview for Preload request</h3>
                    <img style={{ width: '30%', height: 'auto',minHeight:"1px"}} src={PreloadImage} alt='' />
                    <h3>EXAMPLE PRELOAD REQUEST JSON</h3>
                    <p className="note" style={{ width: '70%', padding: '10px'}}><b>NOTE: </b> This example reflects a Preload request with all optional objects; the code is for illustrative purposes only and is not executable.</p>          
                    <pre style={{lineHeight: '1.4rem', fontSize: '0.9rem', fontWeight: '400'}}>
                            {    
`{
    "store_id":"moneris",
    "api_token":"hurgle",
    "checkout_id":"chkt5BF66neris",
    "txn_total":"452.00",
    "environment":"qa",
    "action":"preload",
    "token": [
    {
        "data_key": "abc123datakey1",
        "issuer_id": "645sddfvdrt4tefd"
    },
    {
        "data_key": "abc123datakey2",
        "issuer_id": "645sddfvdrt4tefd"
    },
    {
        "data_key": "abc123datakey3",
        "issuer_id": "645sddfvdrt4tefd"
    }
    ],
    "ask_cvv":"Y"
    "order_no":"",
    "cust_id":"chkt - cust - 0303",
    "dynamic_descriptor":"dyndesc",
    "language":"en",
    "shipping_amount":"200.00",
    "recur":{
        "bill_now":"true",
        "recur_amount":"1.00",
        "start_date":"2021-11-21",
        "recur_unit":"month",
        "recur_period":"1",
        "number_of_recurs":"10"
    },
    "cart":{
        "items":[
            {
                "url":"https:\\/\\/example.com\\/examples\\/item1.jpg",
                "description":"One item",
                "product_code":"one_item",
                "unit_cost":"100.00",
                "quantity":"1"
            },
            {
                "url":"https:\\/\\/example.com\\/examples\\/item2.jpg",
                "description":"Two item",
                "product_code":"two_item",
                "unit_cost":"200.00",
                "quantity":"1"
            },
            {
                "url":"https:\\/\\/example.com\\/examples\\/item3.jpg",
                "description":"Three item",
                "product_code":"three_item",
                "unit_cost":"100.00",
                "quantity":"1"
            }
        ],
        "subtotal":"400.00",
            "tax":{
            "amount":"52.00",
            "description":"Taxes",
            "rate":"13.00"
        }
    },
    "contact_details":{
        "first_name":"bill",
        "last_name":"smith",
        "email":"test@moneris.com",
        "phone":"4165551234"
    },
    "shipping_details":{
        "address_1":"1 main st",
        "address_2":"Unit 2012",
        "city":"Toronto",
        "province":"ON",
        "country":"CA",
        "postal_code":"M1M1M1"
    },
    "billing_details":{
        "address_1":"1 main st",
        "address_2":"Unit 2000",
        "city":"Toronto",
        "province":"ON",
        "country":"CA",
        "postal_code":"M1M1M1"
    }
}
`
                            }
                        </pre>

              <h3>Request fields for Preload request – Required</h3>
              <table>
                        <tbody>
                        <tr>
                            <th>Variable Name</th>
                            <th>Type and limits</th>
                            <th>Description</th>
                        </tr>
                        <tr>
                            <td>store ID<br /><code className="simpleCode2">store_id</code></td>
                            <td><i>String</i><br /><br />10-character alphanumeric</td>
                            <td>Unique identifier provided by Moneris upon merchant account set up</td>
                        </tr>
                        <tr>
                            <td>API token<br /><code className="simpleCode2">api_token</code></td>
                            <td><i>String</i><br /><br />20-character alphanumeric</td>
                            <td>Unique alphanumeric string assigned upon merchant account activation</td>
                        </tr>
                        <tr>
                            <td>checkout ID<br /><code className="simpleCode2">checkout_id</code></td>
                            <td><i>String</i><br /><br />30-character alphanumeric (maximum)</td>
                            <td>Identifies your Moneris Checkout configuration; this is given to you when you configure your page in the Merchant Resource Center</td>
                        </tr>
                        <tr>
                            <td>transaction amount<br /><code className="simpleCode2">txn_total</code></td>
                            <td><i>String</i><br /><br />10-character decimal<br />Up to 7 digits (dollars) + decimal point (.) + 2 digits (cents) after the decimal point</td>
                            <td>The total dollar amount of the transaction</td>
                        </tr>
                        <tr>
                            <td>developmental mode<br /><code className="simpleCode2">environment</code></td>
                            <td><i>String</i><br /><br />alphabetic<br/><code className="simpleCode">qa </code> or <code className="simpleCode2">prod</code></td>
                            <td>Indicates the stage of development you are sending the request for:<br /><br />testing = qa<br />production = prod</td>
                        </tr>
                        <tr>
                            <td>request type<br /><code className="simpleCode2">action</code></td>
                            <td><i>String</i><br /><br />alphabetic<br/></td>
                            <td>Type of request being made to Moneris Checkout server. Allowable values:
                                <br/><code className="simpleCode2">preload</code> or <code className="simpleCode2">receipt</code>
                            </td>
                        </tr>
                        </tbody>
                    </table>

              <h3>Request fields for Preload request – Optional</h3>        
              <table>
                        <tbody>
                        <tr>
                            <th>Variable Name</th>
                            <th>Type and limits</th>
                            <th>Description</th>
                        </tr>
                        <tr>
                            <td>order number<br /><code className="simpleCode2">order_no</code></td>
                            <td><i>String</i><br /><br />50-character alphanumeric<br/>Note: some special characters are not allowed<br/>
                                {`< > $ % = \\? ^ { } [ ] "`}    
                            </td>
                            <td>The order number is a unique identified appended to every financial transaction</td>
                        </tr>
                        <tr>
                            <td>customer ID<br /><code className="simpleCode2">cust_id</code></td>
                            <td><i>String</i><br /><br />50-character alphanumeric<br/>Note: some special characters are not allowed<br/>
                                {`< > $ % = \\? ^ { } [ ] "`}    
                            </td>
                            <td>Merchant defined field that can be used as an identifier <br/>Searchable from the Moneris Merchant Resource Center</td>
                        </tr>
                        <tr>
                            <td>dynamic descriptor<br /><code className="simpleCode2">dynamic_descriptor</code></td>
                            <td><i>String</i><br /><br />20-character alphanumeric<br/> 
                                {`< > $ % = \\? ^ { } [ ] "`} <br/> 
                                total of 22 characters including your merchant name and separator  
                            </td>
                            <td>Merchant-defined description sent on a per-transaction basis that will appear on the credit card statement appen- ded to the merchant’s business name.
                                Dependent on the card issuer, the statement will typically show the dynamic descriptor appended to the merchant's existing business name separated by the "/" character; addi- tional characters will be truncated.
                                NOTE: The 22-character maximum limit must take the "/" into account as one of the characters
                            </td>
                        </tr>
                        <tr>
                            <td>language<br /><code className="simpleCode2">language</code></td>
                            <td><i>String</i><br /><br />2-character alphabetic</td>
                            <td>Determines which language Moneris Checkout will display information in
                                <br/>Allowable values: 
                                <br/>en – English
                                <br/>fr – French
                            </td>
                        </tr>
                        <tr>
                            <td>data key<br /><code className="simpleCode2">data_key</code></td>
                            <td><i>String</i><br /><br />25-character alphanumeric</td>
                            <td>Unique identifier for a Vault profile, and used in future Vault financial transactions to associate a transaction with that profile<br/><br/>Data key is generated by Moneris and returned to you in the Receipt object when the profile is first registered.</td>
                        </tr>
                        <tr>
                            <td>prompt for CVV<br /><code className="simpleCode2">ask_cvv</code></td>
                            <td><i>String</i><br/><br/>1-character alphabetic<br/><br/>Y or N</td>
                            <td>When set to Y, Moneris Checkout will prompt the cardholder to enter their CVV when they select a payment card that has been stored as a token</td>
                        </tr>
                        <tr>
                            <td>shipping amount<br /><code className="simpleCode2">shipping_amount</code></td>
                            <td><i>String</i><br/><br/>10-character decimal</td>
                            <td>Shipping cost of the items to be shipped.</td>
                        </tr>

                        </tbody>
                    </table>

                    <h3>Optional Objects for Preload Requests in Moneris Checkout</h3> 
                    <p>Moneris Checkout also allows you to send optional objects in the Preload request that reflect additional information entered by the customer at checkout, enable additional features, or meet transaction pro- cessing requirements.</p>
                    <p>If you have configured Moneris Checkout to handle these additional items, you do not send the cor- responding object in the Preload request. Only send these optional objects if you are using your own e- commerce page to collect them separately from Moneris Checkout.</p>


                    <table>
                        <tbody>
                        <tr>
                            <th>Variable Name</th>
                            <th>Type and limits</th>
                            <th>Description</th>
                        </tr>
                        <tr>
                            <td>Recurring Billing<br /><code className="simpleCode2">recur</code></td>
                            <td>Object<br /><br />N/A</td>
                            <td>Contains fields related to Recurring Billing</td>
                        </tr>
                        <tr>
                            <td>Shopping Cart<br /><code className="simpleCode2">cart</code></td>
                            <td>Object<br /><br />N/A</td>
                            <td>The virtual shopping cart and its contents</td>
                        </tr>
                        <tr>
                            <td>Contact Details<br /><code className="simpleCode2">contact_details</code></td>
                            <td>Object<br /><br />N/A</td>
                            <td>Customer contact information<br/>
                                This object is returned in the Response to Receipt Request as the Customer
                                Information response object (<code className="simpleCode2">cust_info)</code>
                            </td>
                        </tr>
                        <tr>
                            <td>Shipping Details<br /><code className="simpleCode2">shipping_details</code></td>
                            <td>Object<br /><br />N/A</td>
                            <td>Customer shipping information</td>
                        </tr>
                        <tr>
                            <td>Billing Details<br /><code className="simpleCode2">billing_details</code></td>
                            <td>Object<br /><br />N/A</td>
                            <td>Customer billing information</td>
                        </tr>
                        <tr>
                            <td>token<br /><code className="simpleCode2">token</code></td>
                            <td><i>Array Object</i><br /><br />N/A</td>
                            <td>Array object containing between 1 to 3 pairs of a unique data key and an associated issuer ID, each pair representing an instance of a payment card stored in the Moneris Vault Moneris Checkout will accept a maximum three token pairs of data key and issuer ID for each customer</td>
                        </tr>
                        </tbody>
                    </table>



                    <h3>Preload Request with Recurring Billing - Optional object</h3> 
                    <p>Include this object in Preload request to indicate the start of a series of Recurring Billing transactions that will be managed by Moneris.</p>

                    <h3>Top level object field:</h3>             
                    <code style={{color: "#5f5f5f"}}className="simpleCode2">recur</code>
                    <table style={{maxWidth:"100%",width:"100%",marginTop:"2vh"}}>
                        <tbody>
                        <tr>
                            <th>Variable Name</th>
                            <th>Type and limits</th>
                            <th>Description</th>
                        </tr>
                        <tr>
                            <td>number of recurs<br /><code className="simpleCode2">number_of_recurs</code></td>
                            <td><i>String</i><br />numeric<br/> 1-999</td>
                            <td>The number of times that the transaction must recur</td>
                        </tr>
                        <tr>
                            <td>period<br /><code className="simpleCode2">recur_period</code></td>
                            <td><i>String</i><br />numeric<br/> 1-999</td>
                            <td>Number of recur unit intervals that must pass between recurring billings</td>
                        </tr>
                        <tr>
                            <td>recurring amount<br /><code className="simpleCode2">recur_amount</code></td>
                            <td><i>String</i><br />10-character decimal, minimum three digits<br/>Up to 7 digits (dollars) + decimal point (.) + 2 digits (cents) after the decimal point<br/>EXAMPLE: 1234567.89</td>
                            <td>Dollar amount of the recurring transaction. This amount will be billed on the start date, and then billed repeatedly based on the interval defined by period and recur unit.
                            </td>
                        </tr>

                        <tr>
                            <td>recur unit<br /><code className="simpleCode2">recur_unit</code></td>
                            <td><i>String</i><br />day, week, month or eom</td>
                            <td>Unit to be used as a basis for the interval. Works in conjunction with the period variable to define the billing frequency.</td>
                        </tr>
                        <tr>
                            <td>start date<br /><code className="simpleCode2">start_date</code></td>
                            <td><i>String</i><br />YYYY/MM/DD format</td>
                            <td>Date of the first future recurring billing transaction; this must be a date in the future. If an additional charge will be made immediately, the start now variable must be set to true.</td>
                        </tr>

                        <tr>
                            <td>bill now<br /><code className="simpleCode2">bill_now</code></td>
                            <td><i>String</i><br /><code className="simpleCode2">true</code> or <code className="simpleCode2">false</code></td>
                            <td>Set to true if a charge will be made against the card immediately; otherwise set to false.</td>
                        </tr>
                        </tbody>
                    </table>


                    
                    <h3>Preload Request with Shopping Cart - Optional object</h3> 
                    <p>The shopping cart object can contain multiple items (each item is represented as its own array within the Shopping Cart object).</p>
                    <h3>Top level field</h3> 
                    <code style={{color: "#5f5f5f"}}className="simpleCode2">cart</code>
                    
                    <h3>Required Variables for Shopping Cart</h3> 
                    <table>
                        <tbody>
                        <tr>
                            <th>Variable Name</th>
                            <th>Type and limits</th>
                            <th>Description</th>
                        </tr>
                        <tr>
                            <td>shopping cart items<br /><code className="simpleCode2">items</code></td>
                            <td>Object<br />sub-object containing arrays, nested within cart<br/>contains following items in blue</td>
                            <td>Encapsulates the entire array of items in the shopping cart</td>
                        </tr>
                        <tr>
                            <td>URL<br /><code className="simpleCode2">items.url</code></td>
                            <td><i>String</i><br />alphanumeric</td>
                            <td>URL that corresponds to the image Moneris Checkout shopping cart item</td>
                        </tr>
                        <tr>
                            <td>description<br /><code className="simpleCode2">items.description</code></td>
                            <td><i>String</i><br />200-character alphanumeric<br/>Note: some special characters are not allowed <br/>
                                {`< > $ % = \\? ^ { } [ ] "`}   </td>
                            <td>Describes the item in the shopping cart</td>
                        </tr>

                        <tr>
                            <td>product code<br /><code className="simpleCode2">items.product_code</code></td>
                            <td><i>String</i><br />50-character decimal<br/>Note: some special characters are not allowed<br/>
                                {`< > $ % = \\? ^ { } [ ] "`}    </td>
                            <td>The SKU for the item</td>
                        </tr>
                        <tr>
                            <td>unit cost<br /><code className="simpleCode2">items.unit_cost</code></td>
                            <td><i>String</i><br />10-character decimal<br/>Up to 7 digits (dollars) + decimal point (.) + 2 digits (cents) after the decimal point<br/>EXAMPLE: 1234567.89 </td>
                            <td>Per-unit cost of the item</td>
                        </tr>

                        <tr>
                            <td>quantity<br /><code className="simpleCode2">items.quantity</code></td>
                            <td><i>String</i><br />numeric<br/>6 characters maximum</td>
                            <td>Number of individual instances of the given item in the shopping cart</td>
                        </tr>



                        <tr>
                            <td>subtotal<br /><code className="simpleCode2">subtotal</code></td>
                            <td><i>String</i><br />10-character decimal<br/>
                            Up to 7 digits (dollars) + decimal point (.) + 2 digits (cents) after the decimal point<br/>EXAMPLE: 1234567.89 
                            </td>
                            <td>Total dollar amount of the shopping cart, before taxes</td>
                        </tr>

                        <tr>
                            <td>tax<br /><code className="simpleCode2">tax</code></td>
                            <td>Object<br />sub-object nested within cart<br/>contains following items in blue</td>
                            <td>Contains information related to taxes charged on the items in the shopping cart.</td>
                        </tr>

                        <tr>
                            <td>tax amount<br /><code className="simpleCode2">tax.amount</code></td>
                            <td><i>String</i><br />10-character decimal<br/>Up to 7 digits (dollars) + decimal point (.) + 2 digits (cents) after the decimal point<br/>EXAMPLE: 1234567.89 </td>
                            <td>Dollar amount of taxes</td>
                        </tr>

                        <tr>
                            <td>tax description<br /><code className="simpleCode2">tax.description</code></td>
                            <td><i>String</i><br />50-character alphanumeric<br/>Note: some special characters are not allowed<br/>
                                {`< > $ % = \\? ^ { } [ ] "`}   </td>
                            <td>Describes type of tax being applied</td>
                        </tr>
                        
                        <tr>
                            <td>tax rate<br /><code className="simpleCode2">tax.rate</code></td>
                            <td><i>String</i><br />Must be a numer wth up to 3 decimal places<br/>EXAMPLE: xx or xx.x or xx.xx or xx.xxx </td>
                            <td>Percentage tax rate charged</td>
                        </tr>
                        </tbody>
                    </table>



                    
                    <h3>Preload Request with Contact Details - Optional object</h3>             
                    <h3>Top Level Field</h3>             
                    <code style={{color: "#5f5f5f"}}className="simpleCode2">contact_details</code>
                    <h3>Required Variables for Contact Details Object</h3>
                    <table>
                        <tbody>
                        <tr>
                            <th>Variable Name</th>
                            <th>Type and limits</th>
                            <th>Description</th>
                        </tr>
                        <tr>
                            <td>first name<br /><code className="simpleCode2">first_name</code></td>
                            <td><i>String</i><br />30-character alphanumeric</td>
                            <td>Customer first name</td>
                        </tr>
                        <tr>
                            <td>last name<br /><code className="simpleCode2">last_name</code></td>
                            <td><i>String</i><br />30-character alphanumeric</td>
                            <td>Customer last name</td>
                        </tr>
                        <tr>
                            <td>e-mail<br /><code className="simpleCode2">email</code></td>
                            <td><i>String</i><br />255-character alphanumeric</td>
                            <td>Customer email</td>
                        </tr>

                        <tr>
                            <td>phone number<br /><code className="simpleCode2">phone</code></td>
                            <td><i>String</i><br />30-character alphanumeric</td>
                            <td>Customer phone number</td>
                        </tr>
                       </tbody>
                    </table>

                    {/* <h3>Optional Variables for Contact Details Object</h3>
                    <table>
                        <tbody>
                        <tr>
                            <th>Variable Name</th>
                            <th>Type and limits</th>
                            <th>Description</th>
                        </tr>
                        <tr>
                            <td>allow edit<br /><code className="simpleCode2">allow_edit</code></td>
                            <td><i>String</i><br />1-character alphabetic<br />Y or N</td>
                            <td>Controls customer edits of contact detail fields displayed within the Checkout frame. Optional field, default is N.</td>
                        </tr>
                       </tbody>
                    </table> */}


                    <h3>Preload Request with Shipping Details - Optional object</h3>             
                    <h3>Top Level Field</h3>             
                    <code style={{color: "#5f5f5f"}}className="simpleCode2">shipping_details</code>
                    
                    <h3>Required Variables for Shipping Details Object</h3>
                    <table>
                        <tbody>
                        <tr>
                            <th>Variable Name</th>
                            <th>Type and limits</th>
                            <th>Description</th>
                        </tr>
                        <tr>
                            <td>shipping address line 1<br /><code className="simpleCode2">address_1</code></td>
                            <td><i>String</i><br /><br />50-character alphanumeric<br/>Note: some special characters are not allowed<br/>
                                {`< > $ % = \\? ^ { } [ ] "`}   </td>
                            <td>Customer shipping address</td>
                        </tr>
                        <tr>
                            <td>shipping address line 2<br /><code className="simpleCode2">address_2</code></td>
                            <td><i>String</i><br />50-character alphanumeric<br/>Note: some special characters are not allowed<br/>
                                {`< > $ % = \\? ^ { } [ ] "`}   </td>
                            <td>Customer shipping address</td>
                        </tr>
                        <tr>
                            <td>shipping city<br /><code className="simpleCode2">city</code></td>
                            <td><i>String</i><br />50-character alphanumeric</td>
                            <td>Customer shipping address city</td>
                        </tr>

                        <tr>
                            <td>shipping province<br /><code className="simpleCode2">province</code></td>
                            <td><i>String</i><br />2-character alphanumeric</td>
                            <td>Customer shipping address province. Country subdivision ISO 3166-2</td>
                        </tr>

                        <tr>
                            <td>shipping country<br /><code className="simpleCode2">country</code></td>
                            <td><i>String</i><br />2-character alphanumeric</td>
                            <td>Customer shipping address country<br/>ISO 3166-1 alpha-2</td>
                        </tr>

                        <tr>
                            <td>shipping postal code<br /><code className="simpleCode2">postal code</code></td>
                            <td><i>String</i><br />20-character alphanumeric<br/><p className="note"><b>NOTE: </b> some special characters are not allowed<br/>{`< > $ % = \\? ^ { } [ ] "`}</p></td>
                            <td>Customer shipping address postal code</td>
                        </tr>
                       </tbody>
                    </table>

                    {/* <h3>Optional Variables for Shipping Details Object</h3>
                    <table>
                        <tbody>
                        <tr>
                            <th>Variable Name</th>
                            <th>Type and limits</th>
                            <th>Description</th>
                        </tr>
                        <tr>
                            <td>allow edit<br /><code className="simpleCode2">allow_edit</code></td>
                            <td><i>String</i><br />1-character alphabetic<br />Y or N</td>
                            <td>Controls customer edits of shipping detail fields displayed within the Checkout frame. Optional field, default is N.</td>
                        </tr>
                       </tbody>
                    </table> */}
                    
                    <h3>Billing Details Object</h3>
                    <h4><b>Optional object</b></h4>  
                    <p className="note" style={{ width: '60%', padding: '10px'}}><b>NOTE: </b> Billing-related fields are required when sending 3-D Secure authentication transactions, or else the authentication process may fail.</p>          
                    <h4><b>Top Level Field</b></h4>             
                    <code style={{color: "#5f5f5f"}} className="simpleCode2">billing_details</code>
                    <h3>Required Variables for Billing Details Object</h3>
                    <table>
                        <tbody>
                        <tr>
                            <th>Variable Name</th>
                            <th>Type and limits</th>
                            <th>Description</th>
                        </tr>
                        <tr>
                            <td>billing address line 1<br /><code className="simpleCode2">address_1</code></td>
                            <td><i>String</i><br />50-character alphanumeric<br/>Note: some special characters are not allowed<br/>
                                {`< > $ % = \\? ^ { } [ ] "`}   </td>
                            <td>Customer billing address</td>
                        </tr>
                        <tr>
                            <td>billing address line 2<br /><code className="simpleCode2">address_2</code></td>
                            <td><i>String</i><br />50-character alphanumeric<br/>Note: some special characters are not allowed<br/>
                                {`< > $ % = \\? ^ { } [ ] "`}   </td>
                            <td>Customer shipping address</td>
                        </tr>
                        <tr>
                            <td>billing city<br /><code className="simpleCode2">city</code></td>
                            <td><i>String</i><br />50-character alphanumeric<br/>Note: some special characters are not allowed<br/>
                                {`< > $ % = \\? ^ { } [ ] "`} </td>
                            <td>Customer billing  address city</td>
                        </tr>

                        <tr>
                            <td>billing  province<br /><code className="simpleCode2">province</code></td>
                            <td><i>String</i><br />3-character alphanumeric</td>
                            <td>Customer billing  address province. Country subdivision ISO 3166-2</td>
                        </tr>

                        <tr>
                            <td>billing  country<br /><code className="simpleCode2">country</code></td>
                            <td><i>String</i><br />2-character alphanumeric</td>
                            <td>Customer billing  address country<br/>ISO 3166-1 alpha-2</td>
                        </tr>

                        <tr>
                            <td>billing  postal code<br /><code className="simpleCode2">postal code</code></td>
                            <td><i>String</i><br />20-character alphanumeric</td>
                            <td>Customer billing  address postal code</td>
                        </tr>
                       </tbody>
                    </table>

                    {/* <h3>Optional Variables for Billing Details Object</h3>
                    <table>
                        <tbody>
                        <tr>
                            <th>Variable Name</th>
                            <th>Type and limits</th>
                            <th>Description</th>
                        </tr>
                        <tr>
                            <td>allow edit<br /><code className="simpleCode2">allow_edit</code></td>
                            <td><i>String</i><br />1-character alphabetic<br />Y or N</td>
                            <td>Controls customer edits of billing detail fields displayed within the Checkout frame. Optional field, default is N.</td>
                        </tr>
                       </tbody>
                    </table> */}

                    {/* <h3>Token Object</h3>
                    <h4><b>Optional object</b></h4>  
                    <p>Array object containing between 1 to 3 pairs of a unique data key and an associated issuer ID, each pair representing an instance of a payment card stored in the Moneris Vault. Used for Pay By Token transactions.</p>
                    <h4><b>Top level object field</b></h4>  
                    <code style={{color: "#5f5f5f"}} className="simpleCode2">token</code>

                    <h3>Request fields for Token object</h3>
                    <table>
                        <tbody>
                        <tr>
                            <th>Variable Name</th>
                            <th>Type and limits</th>
                            <th>Description</th>
                        </tr>
                       
                        <tr>
                            <td>data key<br /><code className="simpleCode2">data_key</code></td>
                            <td><i>String</i><br /><br />25-character alphanumeric</td>
                            <td>Unique identifier for a Vault profile, and used in future Vault financial transactions to associate a transaction with that profile<br/><br/>Data key is generated by Moneris and returned to you in the Receipt object when the profile is first registered.</td>
                        </tr>
                        <tr>
                            <td>issuer ID<br /><code className="simpleCode2">issuer_id</code></td>
                            <td><i>String</i><br/><br/>15-character alphanumeric<br/><br/>variable length</td>
                            <td>
                            Unique identifier for the cardholder's stored credentials
                            <br/><br/>
                            Sent back in the response from the card brand when processing a Credential on File transaction
                            <br/><br/>
                            If the cardholder's credentials are being stored for the first time, and the issuer ID was returned in the response, you must save the issuer ID on your system to use in subsequent Credential on File transactions (applies to merchant-initiated transactions only)
                            <br/><br/>
                            The issuer ID must be saved to your systems when returned from Moneris Gateway in the response data, regardless if the value was received or not
                            <br/><br/>
                            As a best practice, if the issuer ID is not returned and you received a value of NULL instead, store that value and send it in the subsequent transaction
                            </td>
                        </tr>
                       </tbody>
                    </table> */}

                    <h3>Response to Preload Request</h3>
                    <pre style={{width:"100%"}}>
{    
`//Successful Preload:

{
    "response":{
       "success":"”true”",
       "ticket":"1585G9G9GIKKGGGIGIOG09G9OGKGJFKFJFNjuit8g9"
    }
}

//Failed Preload
{
    "response":{
       "success":"”false”",
       "error":{
          "billing_details":{
             "data":"”billing address must be set when AVS is enabled”"
          }
       }
    }
}`
}
                            
                    </pre>
              
              <h3>Response Fields – Response to Preload Request</h3>
              <table>
                    <tbody>
                        <tr>
                           
                            <th>Variable Name</th>
                            <th>Type</th>
                            <th>Description</th>
                        </tr>
                        <tr>
                            <td>response "response":<br /></td>
                            <td><i>String</i><br />N/A</td>
                            <td>Top level response object</td>
                        </tr>
                        <tr>
                            <td>success "success":<br/> </td>
                            <td>boolean<br />N/A</td>
                            <td>Denotes whether the Preload request was successful</td>
                        </tr>
                        <tr>
                            <td>ticket "ticket":<br /></td>
                            <td><i>String</i><br /></td>
                            <td>Identifies the specific Moneris Checkout instance
                                <br/>
                                Only returned if success = true</td>
                        </tr>
                        <tr>
                            <td>error "error":<br /></td>
                            <td><i>String</i></td>
                            <td>Sub-object that encapsulates all errors that occurred as a result of the Preload request
                                <br/>
                                Only returned if success = false
                            </td>
                        </tr>
                        <tr>
                            <td>data "data":<br /></td>
                            <td><i>String</i><br /></td>
                            <td>Describes the specific type of error that occurred as a result of some aspect of the Preload request</td>
                        </tr>
                        </tbody>
                    </table>
                {/* <i onClick={() => this.onScrollToTop()} className={"material-icons scrollToTop"}>{'arrow_circle_up'}</i> */}
            </div>
        )
    }

    renderInteractiveTool(){
        const { storeId, apiToken, checkoutId,PreoloadPrequestMessage,txnTotal } = this.props;
        
        return (
            <div className="stepMainContainer">
                <h3>JSON structure overview for Preload request</h3>
                <pre className="sampleCode"><span id="code5">
                   {
`{
  "store_id":"${storeId}",
  "api_token": "${apiToken}",
  "checkout_id":"${checkoutId}",
  "txn_total":"${txnTotal}",
  "environment":"qa",
  "action":"preload"
}`
                   }
                </span></pre>
                <div className="requestButton" 
                    onClick={() => this.handleOnclickButton(PreoloadPrequestMessage, storeId, apiToken, checkoutId, txnTotal)}
                >
                    Preload Request
                </div>
                {this.renderMessage()}
                {/* <i onClick={() => this.onScrollToTop()} className={"material-icons scrollToTop"}>{'arrow_circle_up'}</i> */}
            </div>
        )
    }
    
    render() {
        const { mode } = this.props;
        if(mode === 'interactive_tool')
            return this.renderInteractiveTool();
        else if(mode === 'integration_guide')
            return this.renderDocument();
        else {
            return null;
        }
      }
}

const mapStateToProps = state => {
    const { mode } = state.common.sideNav;
    const { storeId, apiToken, checkoutId, ticket, txnTotal, PreoloadPrequestMessage, PreoloadPrequestResponse } = state.checkout.main;
    return { mode,storeId, apiToken, checkoutId, ticket, txnTotal, PreoloadPrequestMessage, PreoloadPrequestResponse };
}

export default connect(mapStateToProps, { makePreloadRequest,setPreloadRequestMessage,selectResponse })(PreloadRequest)
